import React, { useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';
import CloseButton from '../../atoms/CloseButton';
import './index.scss';

export default function EditorialDetailModalFrame({
  children,
  onClose,
  ariaLabel = 'Details',
  closeLabel = 'Close',
  className = '',
  bodyClassName = '',
}) {
  useEffect(() => {
    const handleKey = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  useEffect(() => {
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = original; };
  }, []);

  const handleBackdropClick = useCallback((event) => {
    if (
      event.target === event.currentTarget
      || event.target?.classList?.contains('post-detail-modal__backdrop')
    ) {
      onClose?.();
    }
  }, [onClose]);

  const portalRoot = typeof document !== 'undefined'
    ? (document.getElementById('portal') || document.body)
    : null;

  if (!portalRoot) return null;

  return ReactDOM.createPortal(
    <div
      className={classNames('post-detail-modal', className)}
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel}
      onMouseDown={handleBackdropClick}
    >
      <div className="post-detail-modal__backdrop" aria-hidden="true" />
      <div className="post-detail-modal__frame">
        <CloseButton
          className="post-detail-modal__close"
          onClick={onClose}
          ariaLabel={closeLabel}
        />
        <div className={classNames('post-detail-modal__body', bodyClassName)}>
          {children}
        </div>
      </div>
    </div>,
    portalRoot,
  );
}

EditorialDetailModalFrame.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  closeLabel: PropTypes.string,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
};
